

























































import { Component, Vue, Ref, Prop, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { required } from '@/utils/validate';
import { trims } from '@/utils/helper';
import { getCookie, setCookie, removeCookie } from '@/utils/storage';
import { ILoginParams } from '@/store/login/types';

const Login = namespace('login');

// 企业会员登录
@Component
export default class OrganizeLogin extends Vue {
  @Login.Action('login') public login!: (params: ILoginParams) => void;
  @Login.State('loading') public loading!: boolean;

  @Prop() public tab!: number;
  @Ref('form') public formRef!: HTMLFormElement;

  public timer: any = null;
  public required = required;
  public rememberOrgCode = false;
  public formData = { username: '', password: '', orgCode: '', clientType: 'manage' };

  // 获取初始组织编码
  public created() {
    this.formData.orgCode = getCookie('orgCode');
    this.rememberOrgCode = getCookie('remember') === 'true';
  }

  // 组织编码更改时（debounce）
  public onCodeChange(orgCode: string) {
    clearTimeout(this.timer);

    this.timer = setTimeout(() => {
      if (this.rememberOrgCode) {
        setCookie('orgCode', orgCode || '', Infinity);
      }
    }, 200);
  }

  // 记住组织编码
  // 由于退出登录时，会对 localStorage 进行 clear，用 cookie 可以防止误删
  public onRememberCode(remember: boolean) {
    if (remember) {
      setCookie('orgCode', this.formData.orgCode, Infinity);
      setCookie('remember', 'true', Infinity);
    } else {
      removeCookie('orgCode');
      removeCookie('remember');
    }
  }

  // 提交表单
  public onSubmit() {
    if (this.formRef.validate()) {
      this.login(trims(this.formData) as ILoginParams);
    }
  }

  @Watch('tab')
  public tabChange() {
    this.formRef.reset();
  }
}
